import axiosClient from './axiosClient';

const authApi = {
  // dang nhap
  signIn: (params) => {
    const url = '/user/login';
    return axiosClient.post(url, params);
  },

  // change password
  changePassword: (params) => {
    const url = `/user/changePassword`;
    return axiosClient.post(url, params);
  },

  // quen mat khau
  forgotPassword: (email) => {
    const url = `/user/forgot`;
    const params = {
      email: email,
    };
    return axiosClient.post(url, params);
  },

  // dat lai mat khau (user da dang nhap)
  resetPasswordLoginUser: (params) => {
    const url = `/user/resetUserPassword`;
    return axiosClient.post(url, params);
  },

  // dat lai mat khau (user chua dang nhap)
  resetPasswordUser: (email, token, newPassword) => {
    const url = `/user/reset`;
    const params = {
      email,
      token,
      newPassword,
    };
    return axiosClient.post(url, params);
  },
};

export default authApi;
